import { render, staticRenderFns } from "./LegalCaseBanner.vue?vue&type=template&id=111ce780&scoped=true&"
import script from "./LegalCaseBanner.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LegalCaseBanner.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LegalCaseBanner.vue?vue&type=style&index=0&id=111ce780&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111ce780",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('111ce780')) {
      api.createRecord('111ce780', component.options)
    } else {
      api.reload('111ce780', component.options)
    }
    module.hot.accept("./LegalCaseBanner.vue?vue&type=template&id=111ce780&scoped=true&", function () {
      api.rerender('111ce780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/legal-case/LegalCaseBanner.vue"
export default component.exports